export default __webpack_public_path__ + "static/media/about-background-1.287aeb08.jpg";